import React from "react";
import { Grid, Button } from "@mui/material";
import AddRejectModal from "./AddRejectModal";
import AddApproveModal from "./AddApproveModal";
import AddReviewModal from "./AddReviewModal";
import AddPendingReviewModal from "./AddPendingReviewModal";
import AddVettedModal from "./AddVettedModal";
export default function ActionButtons({ ID, TYPE, ROLE, STATUS, onEdit, onSubmit }) {
  const permission = {
    sales: [1, 2, 3],
    acc: [12, 7],
    acc_mng: [13],
    cfo: [16],
  };
  const s = Number(STATUS);
  // status ที่แต่ละ role กดได้
  const canAct = {
    sales: s == 1,
    acc_reject: s == 2 || s == 3,   // Reject ได้ตอน New และ Pending Review
    acc_pending: s == 2,              // Pending Review ได้ตอน New เท่านั้น
    acc_review: s == 2 || s == 3,   // Review ได้ตอน New และ Pending Review
    acc_mng: s == 4,
    cfo: s == 5,
  };
  // ซ่อนปุ่มทั้งหมดเมื่อ Completed
  // if (STATUS == STATUS.COMPLETED) return null;
  // sales กรอกฟอร์มแล้ว save status=draft(1)
  // sales send form to acc status=new(2)
  // sales เห็นปุ่ม edit และ send data
  // acc. officer เห็น ปุ่ม pending review และ reviewed และ reject
  // acc. manager เห็นปุ่ม vetted และ reject
  // cfo เห็นปุ่ม approved
  // complete แล้วซ่อนปุ่มทั้งหมด
  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      {/* SALES */}
      {permission.sales.includes(ROLE) && (
        <>
          <Grid item xs={12} sm={6}>
            <Button fullWidth variant="contained" onClick={onEdit}>
              Edit
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              fullWidth
              variant="contained"
              className="approve-btn"
              onClick={() => onSubmit({ STATUS: 2 })}
              disabled={Number(STATUS) !== 1}
            >
              Submit data
            </Button>
          </Grid>
        </>
      )}

      {/* ACCOUNT */}
      {permission.acc.includes(ROLE) && (
        <>
          <Grid item xs={12} sm={4}>
            <AddRejectModal STATUS={STATUS} ID={ID} disabled={!canAct.acc_reject} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <AddPendingReviewModal STATUS={STATUS} ID={ID} TYPE={TYPE} disabled={!canAct.acc_pending} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <AddReviewModal STATUS={STATUS} ID={ID} TYPE={TYPE} disabled={!canAct.acc_review} />
          </Grid>
        </>
      )}
      {permission.acc_mng.includes(ROLE) && (
        <>
          <Grid item xs={12} sm={6}>
            <AddRejectModal STATUS={STATUS} ID={ID} disabled={!canAct.acc_mng} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AddVettedModal STATUS={STATUS} ID={ID} TYPE={TYPE} disabled={!canAct.acc_mng} />
          </Grid>
        </>
      )}
      {permission.cfo.includes(ROLE) && (
        <>
          <Grid item xs={12} sm={6}>
            <AddRejectModal STATUS={STATUS} ID={ID} disabled={!canAct.cfo} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AddApproveModal STATUS={STATUS} ID={ID} TYPE={TYPE} disabled={!canAct.cfo} />
          </Grid>
        </>
      )}
    </Grid>
  );
}
